/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type RequestModalSelectProject_viewer$ref = any;
export type RequestModalSelectProject_viewer = {
    readonly projects?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly name: string | null;
                readonly portfolio: {
                    readonly serviceId: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": RequestModalSelectProject_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "RequestModalSelectProject_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "projects",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 200
                            },
                            {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userIds"
                            }
                        ],
                        "concreteType": "ProjectConnection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProjectEdge",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Project",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "name",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "portfolio",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "PortfolioV2",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/)
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'c00267cc0e6becea860f9ab3dafc63cf';
export default node;
